var styles = {
  "sizeXs": "_sizeXs_1co71lk_9",
  "sizeS": "_sizeS_1co71lk_13",
  "sizeM": "_sizeM_1co71lk_17",
  "sizeL": "_sizeL_1co71lk_21"
};
export { styles as default };
